import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { AuthenticationNgRxActions } from '@geekbears/gb-ngrx-auth-basic';
import { getFailureMessageRxOp } from '@geekbears/gb-ngrx-stack-base';
import { NotificationsService } from '@geekbears/ngx-gb-ui-kit';
import { Store } from '@ngrx/store';
import { isNil } from 'lodash';
import { filter, map, Observable, Subject, takeUntil, tap } from 'rxjs';
import { Router } from '@angular/router';
import { FormBuilder } from '@ngneat/reactive-forms';
import { Actions, ofType } from '@ngrx/effects';

import { forgotPasswordLoadingSelector } from '@modules/company-manager/users/application';
import {
  forgotPasswordFailureAction,
  forgotPasswordSuccessAction,
  UsersActions,
} from '@modules/company-manager/users/application';
import { APP_ROUTES } from '@typings/app-routes.constant';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.page.html',
  styleUrls: ['./forgot-password.page.scss'],
})
export class ForgotPasswordComponent implements OnInit, OnDestroy {
  destroy$: Subject<void> = new Subject();
  form!: FormGroup;
  sendEmailLoading$: Observable<boolean | any>;
  constructor(
    private fb: FormBuilder,
    private notificationsService: NotificationsService,
    private store$: Store,
    private actions$: Actions,
    private router: Router
  ) {
    this.sendEmailLoading$ = this.store$.select(forgotPasswordLoadingSelector);
    this.sendEmailLoading$ = this.store$.select(forgotPasswordLoadingSelector);
    this.form = this.fb.group({
      email: [
        '',
        [
          Validators.required,
          Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$'),
        ],
      ],
    });
  }

  ngOnInit(): void {
    this.onFailureActions();
    this.onEmailSentSuccess();
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onEmailSentSuccess() {
    this.actions$
      .pipe(
        ofType(forgotPasswordSuccessAction),
        filter((action) => {
          return !isNil(action.response);
        }),
        map((action: any) => {
          if (action) {
            this.successModal('The code has been sent to your email');
          }
        }),
        takeUntil(this.destroy$)
      )
      .subscribe();
  }

  sendEmail() {
    if (this.form.valid) {
      localStorage.setItem('resetPasswordEmail', this.form.get('email')?.value);

      this.store$.dispatch(
        UsersActions.forgotPassword({
          emailOrUsername: this.form.get('email')?.value,
        })
      );
    }
  }

  successModal(message: string) {
    this.notificationsService.success(message, {
      duration: 20000,
      icon: 'check-circle',
    });
  }
  errorModal(message: string) {
    this.notificationsService.error(message, {
      duration: 4000,
      icon: 'alert-outline',
    });
  }
  back() {
    this.router.navigateByUrl(APP_ROUTES.authentication['sign-in'].fullPath);
  }

  onFailureActions() {
    this.actions$
      .pipe(
        ofType(forgotPasswordFailureAction),
        map((action) => {
          return action.failure;
        }),
        getFailureMessageRxOp(),
        tap((errorMessage) => {
          if (errorMessage) {
            this.notificationsService.error(errorMessage, {
              duration: 5000,
              icon: 'alert-outline',
            });
          }
        }),
        takeUntil(this.destroy$)
      )
      .subscribe();
  }
}
